export function goToAnchor() {
  let anchorAttrName = "data-goto-anchor";
  let anchorSection = $("[data-anchor]");
  let anchorNav = $(".anchorn-section");
  let openCloseBtn = $(".anchorn-open");
  let anchorDrop = $(".anchorn-drop");
  let anchorButtons = $(".anchorn-drop .btn");

  function scrollTo(position, callback) {
    let duration =
      arguments.length <= 2 || arguments[2] === undefined ? 400 : arguments[2];

    $("body, html").animate({ scrollTop: position }, duration, function () {
      if (callback) {
        callback();
      }
    });
  }

  let getPosition = function getPosition(target) {
    let header = $(".header");
    let anchornSection = $(".anchorn-section");
    let correctionPosition = 0;

    if (header.length) {
      correctionPosition =
        parseInt(header.outerHeight()) + parseInt(anchornSection.outerHeight());
    }
    return parseInt(target.offset().top) - correctionPosition;
  };

  function scrollToRecursion(target) {
    //var duration = arguments.length <= 1 || arguments[1] === undefined ? 200 : arguments[1];

    let position = getPosition(target);

    scrollTo(position, function () {
      let newPosition = getPosition(target);
      /*an extra scroll cycle (starting an additional iteration recursion) is made specifically to make allowances for lazy loading blocks*/
      if (position != newPosition) {
        scrollToRecursion(target);
      }
    });
  }

  $("body").on("click", "[" + anchorAttrName + "]", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const _this = $(this);
    const scrollToSection = $(
      "[data-anchor=" + _this.attr(anchorAttrName) + "]"
    );

    if (scrollToSection.length) {
      const parent = _this.closest("ul");
      $(parent).find(".active").removeClass("active");
      anchorDrop.addClass("is-active");

      if (!parent.closest(".anchorn-drop")) {
        _this.addClass("active");
      } else {
        _this.parent().addClass("active");
      }

      scrollToRecursion(scrollToSection, 400);

      if ($(window).width() < 768 && anchorNav.hasClass("active")) {
        anchorNav.removeClass("active");
        $("body").removeClass("no-scroll");
      }
    }
  });

  $("body").on("click", ".anchorn-section", function (e) {
    if (
      $(window).width() < 768 &&
      anchorNav.hasClass("active") &&
      !$(e.target).closest(".anchorn-box").length
    ) {
      anchorNav.removeClass("active");
      $("body").removeClass("no-scroll");
    }
  });

  openCloseBtn.on("click", function () {
    if ($(window).width() < 768) {
      anchorNav.toggleClass("active");
      $("body").toggleClass("no-scroll");
    }
  });

  $(window).on("scroll", function () {
    let activeSection;
    let winTop = $(window).scrollTop();

    anchorSection.each((index, el) => {
      let itemTop = getPosition($(el));
      if (itemTop - 5 <= winTop && itemTop + $(el).outerHeight() >= winTop) {
        activeSection = $(el).data("anchor");
      }
    });

    anchorDrop[`${activeSection ? "add" : "remove"}Class`]("is-active");

    let anchorBtn = $(`[data-goto-anchor = ${activeSection}]`);

    if (!anchorBtn.parent().hasClass("active")) {
      anchorBtn.parent().siblings().removeClass("active");
      anchorBtn.parent().addClass("active");
    }

    anchorNav[`${$(window).scrollTop() > 0 ? "add" : "remove"}Class`](
      "is-scroll"
    );
  });

  anchorButtons.hover(
    function (e) {
      anchorDrop.addClass("hover-active");
      $(e.target).parent().addClass("hover-active");
    },
    function () {
      anchorDrop.removeClass("hover-active");
      anchorButtons.parent().removeClass("hover-active");
    }
  );
}



// WEBPACK FOOTER //
// ./assets/js/modules/goToAnchor.js